import React, { useEffect } from 'react';
import Icon from 'screens/shared/icon';
import { useSelector } from 'react-redux';
import { hasKeys, getLanColor } from 'utils';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { withRouter } from 'react-router-dom';
import Dropdown from './select-field';

export default withRouter(({
  onChange, hasNewOption = true, privateOnly = false, onPublicChange = () => {}, match, staticContext, lanFilter, external, ...props
}) => {
  const { id: _dcId = '', dcId = '' } = match.params;
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: dataCenter } = useSelector((e) => e);
  let lanItems = dataCenter?.entities?.lans?.items || [];

  useEffect(() => {
    if (!external && !hasKeys(dataCenter) && (dcId || _dcId)) {
      actions.dataCenter.get({ id: dcId || _dcId });
    }
    // eslint-disable-next-line
  }, []);

  const changeHandler = (value) => {
    const isPublic = lanItems.some(({ id, properties: { public: _public = true } = {} }) => id === value && _public);
    onChange(value);
    onPublicChange(isPublic);
  };

  const mapLanOptions = ({ id, properties: { name = '', public: isPublic = true } = {} }) => ([
    id,
    <span className="lan-selector-option relative">
      <Icon name="ethernet" style={{ backgroundColor: getLanColor(id) }} className="-p-b-10 -p-t-3 border-radius" />
      <span className="absolute bottom-1 left-2 l-h-9 f-9 color-white">{isPublic ? 'Public' : 'Private'}</span>
      {`LAN ${id} ${name ? ` - ${name}` : ''}`}
    </span>,
  ]);

  if (privateOnly) lanItems = lanItems.filter(({ properties: { public: e = true } = {} }) => !e);
  if (lanFilter) lanItems = lanItems.filter(lanFilter);

  const lansOptions = hasNewOption ? [['new', 'Create New LAN'], ...lanItems.map(mapLanOptions)] : lanItems.map(mapLanOptions);

  if (privateOnly && !lansOptions.length) {
    props.values = [];
    props.value = '';
  } else {
    props.values = lansOptions;
  }

  return (
    <Dropdown
      {...props}
      onChange={(e) => changeHandler(e.target.value)}
    />
  );
});
